import React, { useState, useEffect } from 'react';
import { historyAPI } from '../api';

export default function GameHistory() {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const response = await historyAPI.getAll();
      setGames(response.data.history);
    } catch (error) {
      console.error('Error fetching history:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-xl text-gray-600">Loading game history...</div>
      </div>
    );
  }

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-8">Game History</h1>

      {games.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-12 text-center">
          <p className="text-gray-500 text-lg mb-4">No games played yet</p>
          <p className="text-gray-400">Your game history will appear here after you host your first trivia night!</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Date</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Game</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Venue</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Winner</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Teams</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Type</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {games.map((game) => (
                <tr key={game.id} className="hover:bg-gray-50 transition">
                  <td className="px-6 py-4 text-sm text-gray-900">
                    {new Date(game.played_at).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4">
                    <p className="font-semibold text-gray-900">{game.game_title}</p>
                    <p className="text-sm text-gray-500">{game.game_code}</p>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900">
                    {game.venue_name || 'Unknown'}
                  </td>
                  <td className="px-6 py-4">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-teal-100 text-teal-700">
                      🏆 {game.winner_team_name}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900">
                    {game.teams_data?.length || 0} teams
                  </td>
                  <td className="px-6 py-4">
                    {game.was_official_game ? (
                      <span className="inline-flex items-center px-2 py-1 rounded text-xs font-semibold bg-teal-100 text-teal-700">
                        Official
                      </span>
                    ) : (
                      <span className="inline-flex items-center px-2 py-1 rounded text-xs font-semibold bg-gray-100 text-gray-700">
                        Custom
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
